import CategoryNavBarCpg from '@page-components/Order/Products/ProductsContent/CategoryNavBar/CategoryNavBarCpg'
import MultiBrandBar from './MultiBrandBar'

export default function CategoriesBar({
  categories,
  website,
  setFilter,
  scrollToCategory,
  categoryRefs,
}) {
  if (!categories) return

  return website?.isMultiBrand ? (
    <MultiBrandBar setFilter={setFilter} scrollToCategory={scrollToCategory} />
  ) : (
    <CategoryNavBarCpg
      categoryRefs={categoryRefs}
      scrollTo={category => scrollToCategory(category)}
      onClick={() => setFilter('')}
    />
  )
}
